(() => {
  if (window.saCushionColourGuard) return;
  window.saCushionColourGuard = true;
  const choices = [{"material":"Funky","label":"Textaafoam Funky 88 Turtle"},{"material":"Funky","label":"Textaafoam Funky 128 Brick"},{"material":"Funky","label":"Textaafoam Funky 133 Sun"},{"material":"Funky","label":"Textaafoam Funky 160 Magnolia"},{"material":"Lodge","label":"Textaafoam Lodge Sand 03"},{"material":"Lodge","label":"Textaafoam Lodge Clay 84"},{"material":"Lodge","label":"Textaafoam Lodge Linen 110"},{"material":"Lodge","label":"Textaafoam Lodge Blossom 166"},{"material":"Lodge","label":"Textaafoam Lodge Blackwhite 6104"}];
  const validChoice = (material, value) => choices.some(choice => choice.material === material && choice.label === value);
  const clearError = field => {
    field.setCustomValidity('');
    field.removeAttribute('aria-invalid');
    const error = field.closest('sa-cushion-colour')?.querySelector('[role="alert"]');
    if (error) error.hidden = true;
  };
  if (!customElements.get('sa-cushion-colour')) {
    customElements.define('sa-cushion-colour', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.addEventListener('change', event => {
          if (event.target.matches('[data-sa-cushion-material]')) this.syncMaterial();
          else if (event.target.matches('[data-sa-cushion-colour]')) clearError(event.target);
        }, {signal: this.controller.signal});
        this.syncMaterial();
      }
      disconnectedCallback() { this.controller.abort(); }
      syncMaterial() {
        const material = this.querySelector('[data-sa-cushion-material]:checked')?.value;
        const field = this.querySelector('[data-sa-cushion-colour]');
        if (!field) return;
        const previous = field.value;
        const placeholder = new Option(field.dataset.placeholder, '');
        placeholder.disabled = true;
        field.replaceChildren(placeholder, ...choices.filter(choice => choice.material === material).map(choice => new Option(choice.label, choice.label)));
        field.value = validChoice(material, previous) ? previous : '';
        clearError(field);
        this.querySelectorAll('[data-sa-cushion-card]').forEach(card => card.classList.toggle('product__kleur-card--active', card.dataset.saCushionCard === material));
      }
    });
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.querySelector('[name="product-id"]')?.value !== '11330227863895') return;
    const field = [...document.querySelectorAll('[data-sa-cushion-colour]')].find(input => input.form === form);
    const data = new FormData(form);
    if (field && validChoice(data.get('properties[Bekleding]'), data.get('properties[Gewenste kleur]'))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const message = field?.dataset.error || (document.documentElement.lang.startsWith('en') ? 'Choose upholstery and colour on the product page.' : 'Kies bekleding en kleur op de productpagina.');
    if (field) {
      field.setAttribute('aria-invalid', 'true');
      const error = field.closest('sa-cushion-colour')?.querySelector('[role="alert"]');
      if (error) error.hidden = false;
      field.setCustomValidity(message);
      field.reportValidity();
      field.focus();
    } else {
      form.closest('product-form')?.handleErrorMessage(message);
    }
  }, true);
})();
